import axios from "axios";
import {useContext} from "react";
import {AuthContext} from "../context/authContext";
import {useHistory} from "react-router-dom";

export const usePutRequest = () => {
    const {state, dispatch} = useContext(AuthContext);
    const history = useHistory();
    const urlApiBackend = process.env.REACT_APP_URL_API_BACKEND;

    const executePutRequest = (api, payload) => {
        return axios.put(`${urlApiBackend}${api}`, payload, {
            headers: {
                'content-type': 'application/json',
				'Access-Control-Allow-Origin': '*',
				'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
                Authorization: 'Bearer ' + state.token,
            },
        }).catch(response => {
            console.error("error response", response);
            manageResponse(response);
            return response;
        });
    };

    const manageResponse = (response) => {
        if (response.response !== undefined) {
            if (response.response.status === 401) {
                console.error("Error 401");
                redirectToLogIn(dispatch);
            } else if (response.response.status === 403) {
                console.error("Error 403");
                redirectToForbidden(history);
            } else if (response.response.status === 404) {
                console.error("Error 404");
                redirectTo404(history);
            }
        }
    };

    const redirectToLogIn = (dispatch) => {
        console.log("Redirect to Login");
        dispatch({type: 'LOG_OUT'});
        history.push("/");
    };

    const redirectToForbidden = (history) => {
        console.log("Redirect to Forbidden");
        history.push("/notAllowed");
    };

    const redirectTo404 = (history) => {
        console.log("Redirect to 404");
        history.push("/notFound");
    };

    return [executePutRequest];
};